import * as React from "react";
import type { SVGProps } from "react";
const SvgContinuousPersonalization = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={66}
    fill="none"
    {...props}
  >
    <path
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M30.712 26.776a4.91 4.91 0 1 0 0-9.82 4.91 4.91 0 0 0 0 9.82ZM37.792 38.316h-14.09c-.73 0-1.39-.5-1.47-1.22-.64-5.73 5.4-7.27 8.71-7.3 7.13.42 8.51 4.53 8.27 7.34-.06.71-.71 1.19-1.42 1.19v-.01ZM42.862 49.056l9.04 14.37a3.37 3.37 0 0 0 4.86.91l2.54-1.88a3.37 3.37 0 0 0 .46-5l-11.58-12.48c-2.78-3-7.5.62-5.32 4.09v-.01Z"
    />
    <path
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M30.593 48.736c11.31 0 20.48-9.169 20.48-20.48 0-11.31-9.17-20.48-20.48-20.48-11.311 0-20.48 9.17-20.48 20.48 0 11.311 9.169 20.48 20.48 20.48Z"
    />
    <path
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M37.422 54.646c-4.41 1.14-9.16 1.2-13.88-.06-14.54-3.9-23.17-18.84-19.27-33.38 3.9-14.54 18.84-23.17 33.38-19.27 14.54 3.9 23.17 18.84 19.27 33.38-.33 1.22-.73 2.4-1.21 3.54"
    />
    <path
      fill="#26A3DD"
      stroke="#26A3DD"
      strokeWidth={0.25}
      d="m52.414 35.41-.117.05.05.116 2.45 5.6.053.121.117-.06 5.552-2.79.113-.058-.059-.113-.476-.903-.057-.109-.11.056-4.44 2.234-1.956-4.478-.05-.112-.113.047-.957.4Z"
    />
  </svg>
);
export default SvgContinuousPersonalization;
